import { Grid, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { ThemePalette } from 'mui.theme';
import SuggestionItems from './SuggestionItems';
import MultiColorCircularLoader from 'views/Production/components/BoxLoader/MultiColorCircularLoader';
import { type AggregatedResult } from 'views/Utilization/AllFleet';
import useAppTheme from 'hooks/useAppTheme';
import { useAppSelector } from 'store/hook';
import { useTranslation } from 'react-i18next';
import { CLIENT_THEME, clientThemePalette } from 'utils/clientTheme';

const _palette = clientThemePalette[CLIENT_THEME];

interface Props {
  minHeight: string;
  data: AggregatedResult;
  assetType: string;
  setSuggestionData: any;
}

const Suggestions = ({
  minHeight,
  data,
  assetType,
  setSuggestionData,
}: Props) => {
  const { t } = useTranslation();
  const { enableDarkTheme } = useAppTheme();
  const palette = enableDarkTheme ? _palette.dark : _palette.light;

  const isLoading = useAppSelector(
    (state) => state.utilizationReducer.loadingStates.isLoadingFleetSummary
  );

  return (
    <Grid item lg={3} md={6} sm={12}>
      <Box
        sx={{
          padding: 2,
          backgroundColor: enableDarkTheme
            ? palette.boxBackground
            : palette.toolBarBackground,
          borderRadius: '5px',
          border: `1px solid ${palette.borderGrey}`,
          minHeight,
          maxHeight: '300px', // Fixed height for the list
          overflowY: 'auto', // Enable vertical scrolling
        }}
      >
        <Typography
          sx={{
            fontSize: '13px',
            fontWeight: '600',
            color: palette.textPrimary,
          }}
        >
          {t('suggestions')}
        </Typography>
        <Box
        // sx={{
        //   paddingTop: '10px',
        // }}
        >
          {isLoading ? (
            <MultiColorCircularLoader height="300px" />
          ) : data !== undefined ? (
            <SuggestionItems
              data={data}
              assetType={assetType}
              setSuggestionData={setSuggestionData}
            />
          ) : (
            <Typography sx={{ fontSize: '10px', fontWeight: 'normal' }}>
              {t('no_data_available_currently')}
            </Typography>
          )}
        </Box>
      </Box>
    </Grid>
  );
};

export default Suggestions;
